module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "card": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Verzendkosten",
      "active": ""
    }
  }, [_c('shipping-cost-tab')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Commisies"
    }
  }, [_c('commission-tab')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Order meldingen",
      "active": ""
    }
  }, [_c('order-notification-tab')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Merk levertijden",
      "active": ""
    }
  }, [_c('brand-delivery-time-tab')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Amazon xml",
      "active": ""
    }
  }, [_c('amazon-xml-upload-tab')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-124488b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/settings/SettingsPage.vue
// module id = 694
// module chunks = 1